import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH, ROOM_VIDEOS } from '@/config';

const PANEL_WIDTH = 360;

export class RoomVideoLayer {
  private container?: HTMLDivElement;
  private videoEl?: HTMLVideoElement;
  private aktivKey: string | null = null;
  private resizeObserver?: ResizeObserver;
  private resizeHandler?: () => void;

  constructor(private scene: Phaser.Scene) {}

  visFor(etasjeId: string): void {
    const path = ROOM_VIDEOS[etasjeId];
    if (!path) {
      this.skjul();
      return;
    }
    if (this.aktivKey === etasjeId && this.container) {
      this.posisjoner();
      return;
    }
    this.skjul();

    const canvas = this.scene.game.canvas;
    const parent = canvas.parentElement;
    if (!parent) return;
    parent.style.position = parent.style.position || 'relative';

    const div = document.createElement('div');
    div.style.position = 'absolute';
    div.style.overflow = 'hidden';
    div.style.pointerEvents = 'none';
    div.style.zIndex = '0';
    div.style.background = '#f4ead5';
    parent.appendChild(div);
    this.container = div;

    const video = document.createElement('video');
    video.src = path;
    video.autoplay = true;
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.style.position = 'absolute';
    video.style.inset = '0';
    video.style.width = '100%';
    video.style.height = '100%';
    video.style.objectFit = 'contain';
    video.style.display = 'block';
    div.appendChild(video);
    this.videoEl = video;
    video.addEventListener('loadeddata', () => {
      console.info(`[RoomVideo] ${etasjeId} lastet: ${video.videoWidth}x${video.videoHeight}`);
    });
    video.addEventListener('error', () => {
      console.warn(`[RoomVideo] ${etasjeId} feilet:`, video.error);
    });
    void video.play().catch((err) => {
      console.warn(`[RoomVideo] ${etasjeId} autoplay blokkert:`, err);
    });

    this.aktivKey = etasjeId;
    this.posisjoner();

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.posisjoner());
      this.resizeObserver.observe(canvas);
    }
    this.resizeHandler = () => this.posisjoner();
    window.addEventListener('resize', this.resizeHandler);
  }

  skjul(): void {
    this.aktivKey = null;
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = undefined;
    }
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = undefined;
    }
    if (this.videoEl) {
      try {
        this.videoEl.pause();
      } catch {
        // ignore
      }
      this.videoEl.removeAttribute('src');
      this.videoEl.load();
      this.videoEl = undefined;
    }
    this.container?.remove();
    this.container = undefined;
  }

  private posisjoner(): void {
    if (!this.container) return;
    const canvas = this.scene.game.canvas;
    const parent = canvas.parentElement;
    if (!parent) return;
    const canvasRect = canvas.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const scaleX = canvasRect.width / GAME_WIDTH;
    const scaleY = canvasRect.height / GAME_HEIGHT;
    const roomWidth = (GAME_WIDTH - PANEL_WIDTH) * scaleX;
    const roomHeight = GAME_HEIGHT * scaleY;
    const offsetX = canvasRect.left - parentRect.left;
    const offsetY = canvasRect.top - parentRect.top;

    this.container.style.left = `${offsetX}px`;
    this.container.style.top = `${offsetY}px`;
    this.container.style.width = `${roomWidth}px`;
    this.container.style.height = `${roomHeight}px`;
  }
}
